import { type ComponentProps, type FC } from "react";
import { useInView } from "react-intersection-observer";
import { type DetailWorkCassette } from "@userFrontend/features/publication/components/DetailWorkCassette";
import { Presentation } from "./Presentation";
import { useRecommendWorksSection } from "./useRecommendWorksSection";

type Props = {
  fetchUrl: string;
  headingText: string;
  subHeadingText?: string;
  gaActionPrefix: string;
  // inViewを利用した再フェッチを有効にしたい場合、trueにする
  refetchTrigger?: boolean;
};

export const DetailWorkCassettes: FC<Props> = ({
  fetchUrl,
  headingText,
  subHeadingText,
  gaActionPrefix,
  refetchTrigger = false,
}) => {
  const { ref, inView: originalInView } = useInView();
  const inView = refetchTrigger ? originalInView : false;

  const cassettes: ComponentProps<typeof DetailWorkCassette>[] | undefined =
    useRecommendWorksSection(fetchUrl, gaActionPrefix, inView);

  return (
    <div ref={refetchTrigger ? ref : undefined}>
      {cassettes ? (
        <Presentation
          headingText={headingText}
          subHeadingText={subHeadingText}
          cassettes={cassettes}
        />
      ) : null}
    </div>
  );
};
